const semanticClassNames = {
  container: 'list-item-select__container',
} as const;

export { semanticClassNames };
